import './LinkButton.scss';

function LinkButton(props) {
     const { link, type, children, size } = props;

     return (
          <div className={`button-link_wrapper button-link_wrapper__${size}`}>
               <a
                    className={`button-link button-link__${type} button-link__${size}`}
                    rel="noreferrer"
                    href={link}
                    target="blank"
               >
                    {children}
               </a>
          </div>
     );
}

export default LinkButton;
